<template>
    <v-container>
        <entity-filter
            class="mb-n1"
            :isLoading="isLoading"
            useEvents
            :teams="teams"
            start-with-default-team
            @change="filterChange"
        ></entity-filter>
        <event-time-table
            v-if="selectedEvent"
            :event="event"
            :slot-data="filteredEncounters"
            :monster-slots="monsterSlots"
            :place-holders="placeHolders"
            :show-monster-slots="true"
            read-route-name="readEncounter"
            @slotSelected="handleSlotSelected"
        />
    </v-container>
</template>
<script>
import api from '@/api'
import { mapState, mapGetters } from 'vuex'
import { uniqBy } from 'lodash'
import EventTimeTable from '../../components/EventTimeTable'
import EntityFilter from '../../components/EntityFilter.vue'

export default {
    name: 'EncounterTimetable',
    components: {
        'event-time-table': EventTimeTable,
        'entity-filter': EntityFilter,
    },
    data() {
        return {
            tabs: null,
            isLoading: false,
            selectedEvent: 0,
            encounters: [],
            selectedStatus: null,
            teams: [],
            selectedTeam: 0,
            searchTerm: null,
            eventSlots: [],
        }
    },
    computed: {
        ...mapState(['user']),
        ...mapGetters(['events', 'nextEvent', 'currentEvent']),
        filteredEncounters() {
            let encounters = this.encounters
            if (this.selectedStatus != null) {
                encounters = encounters.filter(x => x.statusId == this.selectedStatus)
            }
            if (this.selectedTeam > 0) {
                encounters = encounters.filter(x => x.teamId == this.selectedTeam)
            }
            return encounters.map(x => {
                return {
                    dayId: x.day.id,
                    time: x.timeAsMinutes,
                    text: `${this.selectedTeam === 0 ? `(${x.teamName}) - ` : ''}${
                        x.plotName
                    } - ${this.formatEncounterName(x)}`,
                    statusId: x.statusId,
                    id: x.keyId,
                }
            })
        },
        userDefaultTeamId() {
            if (this.user && this.user.defaultTeam) {
                let teamId = parseInt(this.user.defaultTeam)
                if (!isNaN(teamId)) return teamId
            }
            return -1
        },
        event() {
            if (!this.selectedEvent || !this.events || this.events.length === 0) return
            let event = this.events.find(x => x.id === this.selectedEvent)
            return event
        },
        monsterSlots() {
            return this.eventSlots
                .filter(x => x.eventSlotTypeId === 1)
                .map(x => {
                    return {
                        dayId: x.day.id,
                        time: x.timeAsMinutes,
                        duration: x.durationMinutes,
                        text: `${x.comment}`,
                        id: x.id,
                    }
                })
        },
        placeHolders() {
            let teamFilter = this.selectedTeam // === 0 ? this.userDefaultTeamId : this.selectedTeam
            const teamEncounters = this.encounters.filter(x => x.teamId == teamFilter)
            return this.eventSlots
                .filter(x => x.eventSlotTypeId > 2 && x.teamId === teamFilter)
                .filter(
                    x =>
                        !teamEncounters.some(
                            y =>
                                y.day.id === x.day.id &&
                                y.timeAsMinutes === x.timeAsMinutes &&
                                y.encounterType === x.eventSlotTypeId,
                        ),
                )
                .map(x => {
                    return {
                        dayId: x.day.id,
                        time: x.timeAsMinutes,
                        encounterType: x.eventSlotTypeId,
                        text: `${x.eventSlotType.replace(/([A-Z])/g, ' $1').toUpperCase()} PLACEHOLDER`,
                    }
                })
        },
    },
    watch: {
        selectedEvent() {
            this.getEncounters()
            this.getEventSlots()
        },
        currentEvent() {
            this.selectedEvent = this.currentEvent
        },
    },
    // mounted() {
    //     if (this.currentEvent) {
    //         this.selectedEvent = this.currentEvent
    //     }
    //     let teamIdAsInt = parseInt(this.teamId)
    //     if (!isNaN(teamIdAsInt)) {
    //         this.selectedTeam = teamIdAsInt
    //     }
    // },
    activated() {
        // Instead of onMounted as this component lives in a keep-alive tag with a slightly different lifecycle
        if (this.currentEvent) {
            if (this.selectedEvent === this.currentEvent) {
                this.getEncounters()
                this.getEventSlots()
            } else {
                this.selectedEvent = this.currentEvent
            }
        }
        let teamIdAsInt = parseInt(this.teamId)
        if (!isNaN(teamIdAsInt)) {
            this.selectedTeam = teamIdAsInt
        }
    },
    methods: {
        getEncounters() {
            if (!this.selectedEvent) return
            this.isLoading = true
            api.get(`/encounters?eventId=${this.selectedEvent}`)
                .then(res => {
                    if (this.encounterSort) {
                        this.encounters = this.encounterSort(res)
                    } else {
                        this.encounters = this.orderByUserTeams(res)
                    }
                    this.teams = this.getAllTeam().concat(
                        uniqBy(res, 'teamName').map(x => {
                            return { value: x.teamId, text: x.teamName }
                        }),
                    )
                })
                .finally(() => (this.isLoading = false))
        },
        getAllTeam() {
            return [{ value: 0, text: 'All' }]
        },
        getEventSlots() {
            if (!this.selectedEvent) return
            this.isLoading = true
            let apiUrl = `/eventslots?eventId=${this.selectedEvent}`
            api.get(apiUrl)
                .then(res => {
                    this.eventSlots = res
                })
                .finally(() => (this.isLoading = false))
        },
        orderByUserTeams(encounterArray) {
            if (this.userDefaultTeamId === -1) return encounterArray
            var orderedencounters = encounterArray.sort((a, b) => {
                let ownedA = a.teamId === this.userDefaultTeamId
                let ownedB = b.teamId === this.userDefaultTeamId
                if (ownedA === ownedB) {
                    var nameA = a.name.toUpperCase()
                    var nameB = b.name.toUpperCase()
                    if (nameA < nameB) {
                        return -1
                    }
                    if (nameA > nameB) {
                        return 1
                    }

                    // names must be equal??
                    return 0
                }
                return ownedA ? -1 : 1
            })
            return orderedencounters
        },
        handleSlotSelected(day, time, encounterType) {
            if (this.selectedEvent) {
                this.$router.push({
                    name: 'newEncounter',
                    params: {
                        startingEvent: this.selectedEvent,
                        startingDay: day,
                        startingTime: time,
                        encounterType: encounterType,
                    },
                })
            }
        },
        filterChange(filterState) {
            this.selectedStatus = filterState.selectedStatus
            this.selectedTeam = filterState.selectedTeam
            this.searchTerm = filterState.searchTerm
            this.selectedEvent = filterState.selectedEvent
        },
        formatEncounterName(encounter) {
            const encounterName = encounter.name
            const encounterTypeText =
                encounter.encounterType === 3 ? 'MASS COMBAT' : encounter.encounterType === 4 ? 'LINEAR' : ''
            const firstSpace = encounterName.indexOf(' ')
            return `${encounterTypeText ? `${encounterTypeText} - ` : ''}${
                firstSpace < 0 || firstSpace > 20 ? `${encounterName.substring(0, 10)}...` : encounterName
            }`
            // if (firstSpace < 0 || firstSpace > 20) return `${encounterTypeText} - ${encounterName.substring(0, 10)}...`
            // return `${encounterTypeText} - ${encounterName}`
        },
    },
}
</script>
